import React, { useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";

const randomString = (length: number): string => {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

const ConsentPopup = () => {

  useEffect(() => {
    microsoftTeams.app.initialize();
    microsoftTeams.app.getContext().then(_ => {
      const tenantId = "bb05be88-1b7c-4a5a-93bb-90f1ee800b29";
      const queryParams = {
        tenant: tenantId,
        client_id: import.meta.env.VITE_AZURE_APP_REGISTRATION_ID ?? "",
        response_type: "token",
        scope: `api://31bb6e0b-a747-4973-9477-596e48441768/.default`,
        redirect_uri: window.location.origin + "/auth-end",
        nonce: randomString(16)
      };

      const url = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?`;
      const queryParamsString = new URLSearchParams(queryParams).toString();
      const authorizeEndpoint = url + queryParamsString;

      //Redirect to the Azure authorization endpoint. When that flow completes, the user will be directed to auth-end
      //Go to ClosePopup.js
      window.location.assign(authorizeEndpoint);
    });
  }, []);

  return (
    <div>
      <h1>Redirecting to consent page...</h1>
    </div>
  );
};

export default ConsentPopup;
